module.exports = __webpack_public_path__ + "static/media/trainingfaq.a7468d0d.webp";